"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactFormField = _interopRequireDefault(require("@adsk/alloy-react-form-field"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Caption = _ref => {
  let {
    children,
    captionValues = {}
  } = _ref;
  const {
    text: captionText,
    position: captionPosition
  } = captionValues;
  return /*#__PURE__*/_react.default.createElement(StyledCaption, {
    label: captionText,
    position: captionPosition
  }, children);
};
const StyledCaption = (0, _styledComponents.default)(_alloyReactFormField.default)`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  ${_ref2 => {
  let {
    position,
    label
  } = _ref2;
  return !label ? 'margin: 10px 0 16px 0;' : position === 'top' ? {
    flexDirection: 'column',
    margin: '4px 0 16px 0'
  } : {
    flexDirection: 'column-reverse',
    margin: '10px 0 16px 0'
  };
}}

  > label {
    margin: 0;
    ${_ref3 => {
  let {
    position
  } = _ref3;
  return position !== 'top' && 'margin-top: 4px;';
}};
  }

  [class^='FormField'] div {
    margin: 0;
  }

  [data-testid='FormField__label'] {
    ${_alloyReactTheme.default.typography.labelSmall}
    font-weight: 500;
  }
`;
Caption.propTypes = {
  children: _propTypes.default.node,
  captionValues: _propTypes.default.object
};
var _default = exports.default = Caption;